// src/components/ProfileUpdatePage/Tabs/ContactPersonTab.jsx
import React, { useState, useEffect } from 'react';

const ContactPersonTab = ({ contactPerson, setContactPerson, onSave }) => {
  const [formData, setFormData] = useState(contactPerson);

  useEffect(() => {
    setFormData(contactPerson); // Update form data if parent's contactPerson changes
  }, [contactPerson]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setContactPerson(formData); // Update parent state
    onSave(formData); // Pass data to parent to initiate API call
  };

  return (
    <form onSubmit={handleSubmit} className="profile-form">
      {/* ID is typically not editable, so we won't include it in the form for user input */}
      <div className="form-group">
        <label htmlFor="firstName">First Name</label>
        <input type="text" id="firstName" name="firstName" value={formData.firstName || ''} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label htmlFor="lastName">Last Name</label>
        <input type="text" id="lastName" name="lastName" value={formData.lastName || ''} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label htmlFor="designation">Designation</label>
        <input type="text" id="designation" name="designation" value={formData.designation || ''} onChange={handleChange} />
      </div>
      <div className="form-group">
        <label htmlFor="phoneNumber">Phone Number</label>
        <input type="tel" id="phoneNumber" name="phoneNumber" value={formData.phoneNumber || ''} onChange={handleChange} />
      </div>
      <div className="form-group">
        <label htmlFor="email">Email</label>
        <input type="email" id="email" name="email" value={formData.email || ''} onChange={handleChange} />
      </div>
      <button type="submit">Save Contact Person Details</button>
    </form>
  );
};

export default ContactPersonTab;